import type { BreakpointKey } from "@shared/lib/breakpoints";

export const gridSizeMap = {
  sm: 1,
  md: 1,
  lg: 2,
  xl: 3,
  "2xl": 3,
} satisfies Record<BreakpointKey, number>;
